import { useState } from "react";

const SESSION_KEY_BANNER_DISMISSED = "unsupported_browser_banner_dismissed";

const hasCSSSupport = (css: string) => {
  return typeof CSS !== "undefined" && typeof CSS.supports === "function" && CSS.supports(css);
};

const hasTier2BrowserSupport = () => {
  const hasCascadeLayersSupport = typeof window.CSSLayerBlockRule !== "undefined";
  const hasSelectorSupport = hasCSSSupport("selector(:is(*))");
  const hasBackdropFilterSupport = hasCSSSupport("backdrop-filter: blur(1px)") || hasCSSSupport("-webkit-backdrop-filter: blur(1px)");
  return hasCascadeLayersSupport && hasSelectorSupport && hasBackdropFilterSupport;
};

const readBannerDismissedFromSession = () => {
  try {
    return sessionStorage.getItem(SESSION_KEY_BANNER_DISMISSED) === "true";
  } catch {
    return false;
  }
};

const saveBannerDismissedToSession = () => {
  try {
    sessionStorage.setItem(SESSION_KEY_BANNER_DISMISSED, "true");
  } catch {
    // If sessionStorage is unavailable, the banner will be hidden via state only
  }
};

const shouldShowUnsupportedBrowserBanner = () => {
  const isUnsupportedBrowser = !hasTier2BrowserSupport();
  const isDismissed = readBannerDismissedFromSession();
  return isUnsupportedBrowser && !isDismissed;
};

const useUnsupportedBrowserBanner = () => {
  const [stateIsBannerVisible, setStateIsBannerVisible] = useState(shouldShowUnsupportedBrowserBanner);

  const dismissBanner = () => {
    saveBannerDismissedToSession();
    setStateIsBannerVisible(false);
  };

  return { stateIsBannerVisible, dismissBanner };
};

export default useUnsupportedBrowserBanner;
